import React from 'react';
import {Grid, Typography, Box} from '@mui/material';
import {styled} from '@mui/system';
import {Facebook, LinkedIn, YouTube} from '@mui/icons-material';

const FooterContainer = styled(Box)({
    backgroundColor: '#539165',
    color: 'white',
    padding: '40px 20px',
});

const SocialIconContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    marginTop: '20px',
});

const SocialIcon = styled(Box)({
    margin: '0 10px',
    cursor: 'pointer',
});

const Footer = () => {
    return (
        <FooterContainer>
            <Grid container spacing={4} justifyContent="center">
                <Grid item xs={12} md={4} textAlign="center">
                    <Box mb={2}>
                        <img
                            src="https://res.cloudinary.com/drvydie5q/image/upload/v1720716566/Dynamic%20folders/xtkjneqkhreeiqpizhqh.png"
                            alt="Logo" style={{width: '100px'}}/>
                    </Box>
                    <Typography variant="body1">
                        Explore our top-rated tour booking platform for exclusive travel packages across Nha Trang city.
                        Create lasting memories and cultural experiences with every journey you embark on.
                    </Typography>
                    <SocialIconContainer>
                        <SocialIcon>
                            <Facebook style={{color: 'white'}}/>
                        </SocialIcon>
                        <SocialIcon>
                            <LinkedIn style={{color: 'white'}}/>
                        </SocialIcon>
                        <SocialIcon>
                            <YouTube style={{color: 'white'}}/>
                        </SocialIcon>
                    </SocialIconContainer>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant="h6" style={{fontWeight: 'bold'}}>
                        Locations
                    </Typography>
                    <Typography variant="body2" mt={1}>
                        • A3 Building, Number 2 Nguyen Dinh Chieu Street, Nha Trang City, Khanh Hoa Province
                    </Typography>
                </Grid>
                <Grid item xs={12} md={4}>
                    <Typography variant="h6" style={{fontWeight: 'bold'}}>
                        Support
                    </Typography>
                    <Typography variant="body2" mt={1}>
                        Customer Service
                    </Typography>

                    <Typography variant="body2" mt={2}>
                        <Box display="flex" alignItems="center">
                            <Box mr={1}>
                                <img width={'30px'} height={'30px'} style={{marginTop: '7px'}}
                                     src="https://res.cloudinary.com/drvydie5q/image/upload/v1720680787/Dynamic%20folders/cbridpmgldkjadsduhey.png"
                                     alt="Email Icon"/>
                            </Box>
                            minh.nnh.63qtks@ntu.edu.vn
                        </Box>
                    </Typography>
                    <Typography variant="body2" mt={1}>
                        <Box display="flex" alignItems="center">
                            <Box mr={1}>
                                <img width={'30px'} height={'30px'}
                                     src="https://res.cloudinary.com/drvydie5q/image/upload/v1720680971/Dynamic%20folders/ftcxbe2akvxb2qm19vko.png"
                                     alt="Phone Icon"/>
                            </Box>
                            0346590901
                        </Box>
                    </Typography>
                </Grid>
            </Grid>
        </FooterContainer>
    );
};

export default Footer;
